import en from "./en";
import icon from "../../assets/icon.png";
import icon6 from "../../assets/icon6.png";
import icon7 from "../../assets/icon7.png";
import icon8 from "../../assets/icon8.png";

export const menuItems = [
    en.NAV_BAR.home,
    en.NAV_BAR.aboutus,
    en.NAV_BAR.faq,
    en.NAV_BAR.contact,
];

export const icons = [icon, icon6, icon8, icon, icon7];